var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("searchContainer", {
    attrs: { searchHandler: _vm.search, resetHandler: _vm.reset },
    scopedSlots: _vm._u([
      {
        key: "items",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "row" },
              [
                _c("input-number", {
                  attrs: { options: { id: "id", label: "id" } },
                  model: {
                    value: _vm.filters.id,
                    callback: function($$v) {
                      _vm.$set(_vm.filters, "id", $$v)
                    },
                    expression: "filters.id"
                  }
                }),
                _c("input-text", {
                  attrs: { options: { id: "name", label: "name" } },
                  model: {
                    value: _vm.filters.name,
                    callback: function($$v) {
                      _vm.$set(_vm.filters, "name", $$v)
                    },
                    expression: "filters.name"
                  }
                }),
                _c("select-supplier-types", {
                  attrs: {
                    options: {
                      id: "type",
                      label: "type",
                      placeholder: "placeholders.all"
                    }
                  },
                  model: {
                    value: _vm.filters.type,
                    callback: function($$v) {
                      _vm.$set(_vm.filters, "type", $$v)
                    },
                    expression: "filters.type"
                  }
                }),
                _c("select-supplier-fleets", {
                  attrs: {
                    options: {
                      id: "fleet",
                      label: "fleet",
                      placeholder: "placeholders.all",
                      params: { withNotSet: true }
                    }
                  },
                  model: {
                    value: _vm.filters.fleet,
                    callback: function($$v) {
                      _vm.$set(_vm.filters, "fleet", $$v)
                    },
                    expression: "filters.fleet"
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }